<div class="kt-portlet">
    <div class="kt-portlet__head kt-portlet__head__custom">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                NAKLİYE ARACI BİLGİLERİ
            </h3>
        </div>
    </div>
    <div class="kt-portlet__body">
        <ng-container *ngIf="(bidInfo$ | async) as bid">

            <!-- Teklif Onaylandi durumunda ise form gorunur -->
            <ng-container *ngIf="bid.ihaleDurum == 4 && !(formEnd$ | async)"> 
                <div class="alert alert-info fade show text-center offerForm" role="alert">
                    <div class="alert-icon"><i class="flaticon2-check-mark"></i></div>
                    <div class="alert-text">{{bid.name}} No'lu teklifiniz onaylanmıştır. Lütfen aşağıdaki formu
                        doldurun.</div>
                </div>
                <div class="kt-form kt-form--label-right offerForm">

                    <div class="form-group row">
                        <label class="col-lg-3 offset-lg-3 col-form-label">Araç Plaka</label>
                        <div class="col-lg-2">
                            <input type="text" class="form-control" placeholder="Plaka"
                                [(ngModel)]="updateModel.aracPlakasi">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-3 offset-lg-3 col-form-label">Şoför Adı</label>
                        <div class="col-lg-2">
                            <input type="text" class="form-control" placeholder="Ad Soyad"
                                [(ngModel)]="updateModel.soforAdSoyad">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-3 offset-lg-3 col-form-label">Şoför Telefon</label>
                        <div class="col-lg-2">
                            <input class="form-control" #input type="text" maxlength="14" placeholder="(5xx)-xxx-xxxx"
                                [(ngModel)]="updateModel.soforCepTelefon" name="phoneNumber" #phoneNumber="ngModel"
                                (change)="onChangePhoneNumber()" (keyup)="onKeyupPhoneMask()" required>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-4 offset-lg-4 text-center">
                            <button class="btn btn-success btn-block" (click)="onSubmit()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Sofor bilgileri formu doldurulmus ise... -->
            <ng-container *ngIf="(formEnd$ | async)">
                    <h5>Teşekkür ederiz!</h5>
            </ng-container>

            <ng-container *ngIf="bid.ihaleDurum != 4">
                    <h5>Geçersiz işlem !!</h5>
            </ng-container>
        </ng-container>
    </div>
</div>
<!--<div class="col-md-12 kt-margin-bottom-10-mobile">
			<label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
				<input type="checkbox" name="checkbox1">

				<span></span>
			</label>
		</div>-->